import { render, staticRenderFns } from "./RiskEvaluationWizard.vue?vue&type=template&id=5dec82d4"
import script from "./RiskEvaluationWizard.vue?vue&type=script&lang=js"
export * from "./RiskEvaluationWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports